import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Avatar from "@mui/material/Avatar";
import Prompt from "components/UpStyled/Prompt";
import defaultStyleImage from "assets/images/upstyled/default_background.png";

const PostCardOwner = ({
  index,
  post,
  imageOnly,
  handleClick = () => {},
  editable = false,
  handleDelete,
  handleEdit,
  handleRefresh = () => {},
  ...rest
}) => {
  const [isHover, setIsHover] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  const primaryImage = post?.metadata?.coverImage;
  const owner = post?.store;

  const handleDefaultDelete = async () => {
    if (!post?.id) {
      return toast.error("Could not find the post ID!");
    }
    try {
      await api.post.delete(post.id);
      setDeleteVisible(false);
      handleRefresh();

      toast.success("Successfully delete the post!");
    } catch (err) {
      console.log(err);
      toast.error("Delete post failed!");
    }
  };
  return (
    <div>
      <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <SuiBox
          onClick={(e) => handleClick(e, post)}
          sx={{
            cursor: "pointer",
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.secondary.state, 0.1),
                rgba(gradients.secondary.state, 0.1)
              )}`,
            boxShadow: ({ boxShadows: { lg } }) => (isHover ? lg : "none"),
            overflow: "hidden",
            position: "relative",
            display: "flex",
            minWidth: 0,
            width: "100%",
            height: "100%",
            ...rest?.sx,
          }}
          className="hover-parent"
        >
          <ImageCardWrapper
            data={primaryImage}
            height={234}
            width={300}
            draggable={false}
            {...rest}
          />

          <SuiBox className="overlay">
            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiTypography
                variant="body1"
                textTransform="none"
                color="white"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {post?.title}
              </SuiTypography>{" "}
            </SuiBox>
          </SuiBox>
          {editable ? (
            <SuiBox
              position="absolute"
              sx={{ bottom: "40%", left: 0, width: "100%", opacity: 0 }}
              className="hover-children"
            >
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                <SuiButton
                  variant="gradient"
                  color="white"
                  size="small"
                  style={{ padding: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (handleEdit) {
                      handleEdit(e, post);
                    } else {
                      navigate(`/edit-post/${post?.id}`);
                    }
                  }}
                >
                  Edit
                </SuiButton>
                <SuiButton
                  variant="gradient"
                  color="error"
                  size="small"
                  style={{ padding: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (handleDelete) {
                      handleDelete(e, post);
                    } else {
                      setDeleteVisible(true);
                    }
                  }}
                >
                  Remove
                </SuiButton>
              </SuiBox>
            </SuiBox>
          ) : null}
        </SuiBox>
      </div>
      {imageOnly ? null : (
        <SuiBox sx={{ my: 0.5 }}>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center">
            <SuiBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer" }}>
              <SuiTypography
                variant="body1"
                textTransform="none"
                color="dark"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {post?.title}
              </SuiTypography>{" "}
            </SuiBox>
            <SuiBox display="flex" alignItems="center" gap={0.5}>
              <ThumbUpOutlinedIcon /> 0
              <VisibilityOutlinedIcon /> 0
            </SuiBox>
          </SuiBox>
          <SuiBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer" }}>
            <SuiTypography
              variant="body2"
              textTransform="none"
              color="text"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {owner?.name}
            </SuiTypography>{" "}
          </SuiBox>
        </SuiBox>
      )}
      {deleteVisible && post?.id ? (
        <Prompt
          heading="Delete Post"
          text={`Are you sure you want to delete: ${post.title}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => handleDefaultDelete(post)}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
    </div>
  );
};
export default PostCardOwner;
